/**
 * crmsweep: what the office is told after a CRM sweep. PURE, so the wording
 * is tested (`crmSweepNotice.test.ts`).
 */

/** What a sweep left behind, as the edge function keeps it in `org_config.crm_sweep`. */
export interface CrmSweepSummary {
    at: string;
    filled_this_run: number;
    still_missing: number;
    not_in_crm: string[];
    crm_disagrees: string[];
    no_date_in_crm: string[];
    not_checked_yet: number;
    lookups_failed: number;
}

const names = (list: string[], max = 4) =>
    list.length <= max ? list.join(', ') : `${list.slice(0, max).join(', ')} and ${list.length - max} more`;

/**
 * The one line the office reads after a sweep, or null when there is nothing
 * worth saying. Says what was filled, then what is still blank and WHY, each
 * reason with the clients it covers, because the fix for each is in the CRM.
 */
export function sweepNotice(filled: number, s: CrmSweepSummary | null): { title: string; description?: string } | null {
    const blocked = s ? s.not_in_crm.length + s.crm_disagrees.length + s.no_date_in_crm.length : 0;
    if (!filled && !blocked) return null;
    const title = filled
        ? `Filled ${filled} client${filled === 1 ? '’s' : 's’'} date of incorporation from the Tohund Guide CRM`
        : `${blocked} client${blocked === 1 ? ' still has' : 's still have'} no date of incorporation`;
    if (!s || !blocked) return { title };
    const parts = [
        s.not_in_crm.length && `Not found in the CRM by PAN, CIN or GSTIN: ${names(s.not_in_crm)}.`,
        s.crm_disagrees.length && `The CRM has two records that disagree: ${names(s.crm_disagrees)}.`,
        s.no_date_in_crm.length && `The CRM has no date for: ${names(s.no_date_in_crm)}.`,
    ].filter(Boolean);
    return { title, description: `${parts.join(' ')} Correct them in the CRM and Karr picks them up within a week.` };
}
